var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEcommerceDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99163 15H3.33329C2.89127 15 2.46734 14.8244 2.15478 14.5119C1.84222 14.1993 1.66663 13.7754 1.66663 13.3334V5.40837C1.66663 4.96634 1.84222 4.54242 2.15478 4.22985C2.46734 3.91729 2.89127 3.7417 3.33329 3.7417H11.4833C11.9253 3.7417 12.3492 3.91729 12.6618 4.22985C12.9744 4.54242 13.15 4.96634 13.15 5.40837V11.1667",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.125 6.8252H15.4417C15.5908 6.82483 15.7381 6.8584 15.8724 6.92337C16.0067 6.98834 16.1244 7.08301 16.2167 7.2002L18.1 9.7002C18.2925 9.95784 18.3976 10.2703 18.4 10.5919V14.7585C18.4 14.8027 18.3824 14.8451 18.3512 14.8764C18.3199 14.9076 18.2775 14.9252 18.2333 14.9252H15.6917",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7583 16.7167C14.7892 16.7167 15.6249 15.881 15.6249 14.8501C15.6249 13.8191 14.7892 12.9834 13.7583 12.9834C12.7273 12.9834 11.8916 13.8191 11.8916 14.8501C11.8916 15.881 12.7273 16.7167 13.7583 16.7167Z",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84994 16.7167C6.88087 16.7167 7.71661 15.881 7.71661 14.8501C7.71661 13.8191 6.88087 12.9834 5.84994 12.9834C4.81901 12.9834 3.98328 13.8191 3.98328 14.8501C3.98328 15.881 4.81901 16.7167 5.84994 16.7167Z",
    stroke: "#616364",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9 14.9585H7.625",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEcommerceDelivery);
export default __webpack_public_path__ + "static/media/ic-ecommerce-delivery.c3153c1ed400b81f54deccb065c7fc89.svg";
export { ForwardRef as ReactComponent };